export const importScript = (url, callback) => {
  const script = document.createElement("script");
  script.src = url;
  script.defer = true;
  document.body.appendChild(script);
  script.onload = () => {
    if (typeof callback === "function") callback();
  };
};
export const handleChromeRuntimeFn = (profileId) => {
  if (
    ["renovation-crm.nobroker.in", "interiors-crm.nobroker.in"]?.includes(
      window.location.host
    )
  ) {
    try {
      // eslint-disable-next-line no-undef
      chrome.runtime.sendMessage("fkpoipoabekjghhplpafbpipfbofehah", {
        type: "auth",
        uuID: profileId,
        source:
          window.location.host === "interiors-crm.nobroker.in"
            ? "interior"
            : "renovation",
      });
    } catch (error) {
      console.log("error", error);
    }
  }
};
